import { useMemo } from "react";
import { parseISO } from "date-fns";
import {
  type SavedPlotRow,
  type SavedPlotFilterValues,
} from "@/features/map/types";

/**
 * SavedPlotRowの配列にフィルターを適用する
 * @param rows フィルター前の全データ
 * @param filters フィルター条件
 * @returns フィルター適用後のデータ
 */
export const useFilteredRows = (
  rows: SavedPlotRow[],
  filters: SavedPlotFilterValues
): SavedPlotRow[] => {
  return useMemo(() => {
    return rows.filter((row) => {
      // 識別名のフィルタリング
      if (filters.name) {
        if (!row.name.toLowerCase().includes(filters.name.toLowerCase())) {
          return false;
        }
      }

      // 件数のフィルタリング
      if (filters.countFrom !== null) {
        if (row.count < filters.countFrom) return false;
      }
      if (filters.countTo !== null) {
        if (row.count > filters.countTo) return false;
      }

      // 作成日時のフィルタリング
      if (filters.createdAtFrom) {
        const createdAt = parseISO(row.createdAt);
        const filterDate = parseISO(filters.createdAtFrom);
        if (createdAt < filterDate) return false;
      }
      if (filters.createdAtTo) {
        const createdAt = parseISO(row.createdAt);
        const filterDate = parseISO(filters.createdAtTo);
        if (createdAt > filterDate) return false;
      }

      // 更新日時のフィルタリング
      if (filters.updatedAtFrom) {
        const updatedAt = parseISO(row.updatedAt);
        const filterDate = parseISO(filters.updatedAtFrom);
        if (updatedAt < filterDate) return false;
      }
      if (filters.updatedAtTo) {
        const updatedAt = parseISO(row.updatedAt);
        const filterDate = parseISO(filters.updatedAtTo);
        if (updatedAt > filterDate) return false;
      }

      // タグのフィルタリング
      if (filters.tags.length > 0) {
        const rowTags = row.tags ?? [];
        const hasMatchingTag = filters.tags.every((filterTag) =>
          rowTags.some((rowTag) => rowTag.name === filterTag.name)
        );
        if (!hasMatchingTag) return false;
      }

      return true;
    });
  }, [rows, filters]);
};
